import * as React from 'react';

import {isSafeUrlPath} from 'nutshell-core/utils/is-safe-url-path';

import {TextField} from '../textfield/textfield';

import styles from './pathname-field.module.css';

type Props = {
    domainName: string;
    value: string;
    onChange: (arg1: string) => void;
    placeholder?: string;
    onEnter?: () => void;
    hasError?: boolean;
    initialDomainWidth?: number;
};

export function PathnameField(props: Props) {
    const {domainName} = props;

    // createRef creates a new ref on every render so we ensure we get the
    // correct width every time a modal opens
    const domainNameRef = React.createRef();
    const [domainNameWidth, setDomainNameWidth] = React.useState<number | null | undefined>(
        props.initialDomainWidth || null
    );

    React.useLayoutEffect(() => {
        // @ts-expect-error
        if (domainNameRef.current && domainNameRef.current.clientWidth !== 0) {
            // +16px padding for divider line
            // @ts-expect-error
            setDomainNameWidth(domainNameRef.current.clientWidth + 16);
        }
    }, [domainNameRef]);

    return (
        <div className={styles['pathname-field']}>
            <TextField
                // @ts-expect-error
                style={{paddingLeft: domainNameWidth}}
                id='pathname-input-field'
                placeholder={props.placeholder}
                value={props.value}
                onChange={(newPath) => {
                    // No spaces, other URL safety validated on backend
                    const safePath = newPath.replace(' ', '');
                    if (isSafeUrlPath(safePath)) {
                        props.onChange(safePath);
                    }
                }}
                onEnter={props.onEnter}
                hasError={props.hasError}
            />
            {/* @ts-expect-error */}
            <div ref={domainNameRef} className={styles['domain-name-text']}>
                {domainName}
            </div>
        </div>
    );
}
